import { Term } from '../Term';

// Rest Cycles
export const SHORT_REST = <Term>short rest</Term>;
export const LONG_REST = <Term>long rest</Term>;
export const PER_REST = <Term>per rest</Term>;

// Resource Tracking
export const HOPE = <Term>Hope</Term>;
export const STRESS = <Term>Stress</Term>;
export const HIT_POINTS = <Term>Hit Points</Term>;
export const HIT_POINT = <Term>Hit Point</Term>;
export const ARMOR_SLOTS = <Term>Armor Slots</Term>;
export const ARMOR_SLOT = <Term>Armor Slot</Term>;

// Traits
export const AGILITY   = <Term>Agility</Term>;
export const STRENGTH  = <Term>Strength</Term>;
export const FINESSE   = <Term>Finesse</Term>;
export const INSTINCT  = <Term>Instinct</Term>;
export const PRESENCE  = <Term>Presence</Term>;
export const KNOWLEDGE = <Term>Knowledge</Term>;

// Damage Types
export const WEAPON_DAMAGE = <Term>weapon damage</Term>;
export const MAGIC_DAMAGE = <Term>magic damage</Term>;

// Range Terms
export const MELEE = <Term>Melee</Term>;
export const VERY_CLOSE = <Term>Very Close</Term>;
export const CLOSE = <Term>Close</Term>;
export const FAR = <Term>Far</Term>;
export const VERY_FAR = <Term>Very Far</Term>;

// Roll Types
export const SPELLCAST_ROLL = <Term>Spellcast Roll</Term>;
export const REACTION_ROLL = <Term>Reaction Roll</Term>;
export const ACTION_ROLL = <Term>Action Roll</Term>;
export const ATTACK_ROLL = <Term>Attack Roll</Term>;

// Condition States
export const ON_FIRE = <Term>On Fire</Term>;
export const VULNERABLE = <Term>Vulnerable</Term>;
export const FRENZY = <Term>Frenzy</Term>;
export const FRENZIED = <Term>Frenzied</Term>;
export const FRIGHTENED = <Term>Frightened</Term>;
export const SLEEP = <Term>Sleep</Term>;
export const DYING = <Term>Dying</Term>;

// Loadout Mechanics
export const VAULT = <Term>Vault</Term>;
export const LOADOUT = <Term>Loadout</Term>;
export const RECALL_COST = <Term>Recall Cost</Term>;

// Character Concepts
export const DUALITY_DICE = <Term>Duality Dice</Term>;
export const HOPE_DIE = <Term>Hope Die</Term>;
export const FEAR_DIE = <Term>Fear Die</Term>;
export const FEAR = <Term>Fear</Term>;

// Game Mechanics
export const EVASION = <Term>Evasion</Term>;
export const EXPERTISE = <Term>Expertise</Term>;
export const VULNERABLE_DAMAGE = <Term>vulnerable damage</Term>;
export const CONDITION = <Term>Condition</Term>;
export const TRAIT = <Term>Trait</Term>;

// Ability Types
export const ABILITY = <Term>Ability</Term>;
export const SPELL = <Term>Spell</Term>;
export const GRIMOIRE = <Term>Grimoire</Term>;
export const DOMAIN_CARD = <Term>Domain Card</Term>;
export const PROFICIENCY = <Term>Proficiency</Term>;

// Movement & Range
export const MOVEMENT = <Term>Movement</Term>;
export const RANGE = <Term>Range</Term>;

// Combat Concepts
export const ADVANTAGE = <Term>Advantage</Term>;
export const DISADVANTAGE = <Term>Disadvantage</Term>;
export const CRITICAL_HIT = <Term>Critical Hit</Term>;
export const FAILURE = <Term>Failure</Term>;

// Special States & Mechanics
export const RECALL = <Term>Recall</Term>;
export const MARK = <Term>Mark</Term>;
export const SPEND = <Term>Spend</Term>;
export const HEAL = <Term>Heal</Term>;
